import { apiSlice } from "./apiSlice";

export const masterDataSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all master data list
        getMasterDataList: builder.query({
            query: (params) => ({
                url: `Configuration`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllMasterData"],
        }),

        // Create new master data
        createMasterData: builder.mutation({
            query: ({ body }) => ({
                url: `Configuration`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllMasterData"],
        }),

        // Update master data
        updateMasterData: builder.mutation({
            query: ({ body }) => ({
                url: `Configuration`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["AllMasterData"],
        }),

        // Delete master data
        deleteMasterData: builder.mutation({
            query: (id) => ({
                url: `Configuration/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ["AllMasterData"],
        }),

    })
})

export const { useGetMasterDataListQuery, useCreateMasterDataMutation, useUpdateMasterDataMutation, useDeleteMasterDataMutation } = masterDataSlice;
